import { useQuery } from '@tanstack/react-query';
import { getCorrectedResults } from '../../services/correctedResults';
import { QueryKey } from '../../enums/QueryKey';
import dayjs, { Dayjs } from '@utils/dayjs';
import { appTimezone } from '../../config';

export function getCorrectedResultsQueryKey({
    date,
    workingUnitLocation,
}: {
    date: string | Date | Dayjs;
    workingUnitLocation: number;
}) {
    // Use app timezone since slots represent business times in Berlin
    const dateFrom = dayjs(date).tz(appTimezone).startOf('month').toISOString();
    const dateTo = dayjs(date).tz(appTimezone).endOf('month').toISOString();

    return [QueryKey.CorrectedResults, { dateFrom, dateTo, workingUnitLocation }];
}

export function useCorrectedResults({
    date,
    workingUnitLocation,
}: {
    date: string | Date | Dayjs;
    workingUnitLocation: number;
}) {
    // Use app timezone since slots represent business times in Berlin
    const dateFrom = dayjs(date).tz(appTimezone).startOf('month').toISOString();
    const dateTo = dayjs(date).tz(appTimezone).endOf('month').toISOString();

    const { data, ...rest } = useQuery({
        queryKey: getCorrectedResultsQueryKey({ date, workingUnitLocation }),
        queryFn: () => getCorrectedResults({ dateFrom, dateTo, workingUnitLocation }),
        enabled: !!date && !!workingUnitLocation,
        refetchOnWindowFocus: false,
    });

    return {
        correctedResults: data || [],
        data: data || [],
        ...rest,
    };
}
